import { DataManagementConfig } from '@shared/components/data-management';
import { SubjectTableData, SubjectFormData } from '../types';
import { AddSubjectDialog } from '../components';
import {
  useSubjects,
  useCreateSubject,
  useUpdateSubject,
  useDeleteSubject,
} from '../hooks/useSubjects';

// Factory function to create subjects config for a specific domain
export const createSubjectsConfig = (
  tenantId: string,
  domainId: string,
  navigate?: (path: string) => void
): DataManagementConfig<SubjectTableData, SubjectFormData, SubjectFormData> => {
  return {
    hooks: {
      useQuery: () => useSubjects(tenantId, domainId),
      useCreate: () => useCreateSubject(tenantId, domainId),
      useUpdate: () => useUpdateSubject(tenantId, domainId),
      useDelete: () => useDeleteSubject(tenantId, domainId),
    },

    table: {
      title: 'Subjects',
      columns: [
        {
          label: 'Name',
          key: 'name',
        },
        {
          label: 'Code',
          key: 'code',
        },
        {
          label: 'Description',
          key: 'description',
          render: (value: string | number | undefined) => (value as string) || null,
        },
        {
          label: 'Created',
          key: 'createdAt',
          render: (value: string | number | undefined) =>
            value ? new Date(value as string).toLocaleDateString() : null,
        },
      ],
      emptyMessage: 'No subjects found for this institute',
      errorMessage: 'Failed to load subjects. Please try refreshing the page.',
    },

    actions: {
      create: {
        label: 'Add Subject',
        dialog: AddSubjectDialog,
      },
      edit: {
        label: 'Edit',
      },
      delete: {
        label: 'Delete',
        confirmTitle: 'Delete Subject',
        confirmMessage: (subject) =>
          `Are you sure you want to delete "${subject.name}"? This action cannot be undone and may affect associated courses and content.`,
      },
    },

    features: {
      search: true,
      pagination: true,
      onRowClick: navigate
        ? (subject) => {
            navigate(
              `/app/manage/universities/${tenantId}/institutes/${domainId}/subjects/${subject.id}`
            );
          }
        : undefined,
    },
  };
};
